export default {
  'profileaccounts.accountsmanagement': '銀行口座の管理',
  'profileaccounts.bankname': '銀行名',
  'profileaccounts.branchname': '支店名',
  'profileaccounts.accountno': '口座番号',
  'profileaccounts.cardno': 'カード番号',
  'profileaccounts.shebano': 'IBANコード',
  'profileaccounts.ismain': '既定の口座ですか',
  'profileaccounts.register': '追加',
  'profileaccounts.delete': '削除',
  'profileaccounts.deleteaccount': '銀行口座を削除',
  'proprofileaccountsfile.cancel': 'キャンセル',
  'profileaccounts.deleteconfirmation': '銀行口座を削除してよろしいですか ?',
  'profileaccounts.accountadd': '銀行口座が追加されました',
  'profileaccounts.tryagain': 'もう一度やり直してください',
  'profileaccounts.enterinfo': 'アカウント情報を入力してください',
  'profileaccounts.addaccount': '銀行口座を追加',
  'profileaccounts.cardno-account': 'カード番号',
};
